export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  updateStatus: string;
  latestChapter: string;
  rating: number;
  popularity: number;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部', description: '浏览所有漫画资源', icon: 'ri-apps-2-line' },
  { slug: 'shonen', name: '热血少年', description: '热血、友情、战斗题材漫画', icon: 'ri-fire-line' },
  { slug: 'romance', name: '恋爱校园', description: '青春恋爱与校园生活漫画', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻冒险', description: '奇幻世界观与冒险故事', icon: 'ri-magic-line' },
  { slug: 'comedy', name: '搞笑日常', description: '轻松幽默的日常喜剧漫画', icon: 'ri-emotion-laugh-line' },
  { slug: 'horror', name: '悬疑恐怖', description: '紧张刺激的悬疑恐怖漫画', icon: 'ri-ghost-line' },
  { slug: 'scifi', name: '科幻未来', description: '科幻设定与未来世界观漫画', icon: 'ri-rocket-line' },
  { slug: 'slice', name: '治愈日常', description: '温暖治愈系日常漫画', icon: 'ri-sun-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '星界战记',
    author: '林风',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20style%20illustration%20of%20a%20young%20warrior%20with%20a%20sword%20standing%20in%20a%20fantasy%20battlefield%2C%20vibrant%20colors%2C%20clean%20lineart%2C%20Japanese%20manga%20aesthetic%2C%20action%20pose%2C%20dramatic%20lighting%2C%20simple%20white%20background%2C%20professional%20illustration%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'shonen',
    description: '在遥远的星界大陆上，少年剑士踏上寻找传说之剑的旅程，一路上结识伙伴、战胜强敌。',
    updateStatus: '连载中',
    latestChapter: '第 128 话',
    rating: 4.8,
    popularity: 985000,
  },
  {
    id: 'comic-2',
    title: '樱花下的约定',
    author: '苏小暖',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20manga%20illustration%20of%20a%20couple%20under%20cherry%20blossom%20trees%20at%20sunset%2C%20soft%20pink%20tones%2C%20shojo%20manga%20style%2C%20delicate%20lineart%2C%20warm%20atmosphere%2C%20simple%20white%20background%2C%20heartwarming%20romance%20theme&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'romance',
    description: '高中最后一年，她与他约定在樱花树下相见。青春的故事，从这里开始。',
    updateStatus: '已完结',
    latestChapter: '第 86 话（完）',
    rating: 4.9,
    popularity: 756000,
  },
  {
    id: 'comic-3',
    title: '暗夜行者',
    author: '墨渊',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20manga%20illustration%20of%20a%20mysterious%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20alley%20at%20night%2C%20noir%20style%2C%20dramatic%20shadows%2C%20thriller%20theme%2C%20monochrome%20with%20red%20accents%2C%20clean%20composition%2C%20professional%20illustration&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'horror',
    description: '城市暗处隐藏着不为人知的秘密，一位神秘侦探在黑暗中追寻真相。',
    updateStatus: '连载中',
    latestChapter: '第 56 话',
    rating: 4.7,
    popularity: 623000,
  },
  {
    id: 'comic-4',
    title: '魔法学院录',
    author: '七夜',
    cover: 'https://readdy.ai/api/search-image?query=A%20colorful%20fantasy%20manga%20illustration%20of%20young%20wizards%20and%20witches%20studying%20magic%20in%20a%20grand%20academy%20hall%2C%20magical%20effects%2C%20bright%20vibrant%20colors%2C%20adventure%20theme%2C%20simple%20white%20background%2C%20professional%20manga%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'fantasy',
    description: '普通少年意外进入魔法学院，在充满奇幻的校园里展开一段不可思议的冒险。',
    updateStatus: '连载中',
    latestChapter: '第 203 话',
    rating: 4.6,
    popularity: 1102000,
  },
  {
    id: 'comic-5',
    title: '今天也超好笑',
    author: '笑匠',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20expressive%20manga%20illustration%20of%20a%20group%20of%20high%20school%20friends%20laughing%20together%2C%20comedy%20slice%20of%20life%20style%2C%20bright%20and%20cheerful%20colors%2C%20exaggerated%20expressions%2C%20simple%20white%20background%2C%20light%20hearted%20manga%20art&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'comedy',
    description: '一群高中生的爆笑日常，每一话都能让你笑到停不下来！',
    updateStatus: '连载中',
    latestChapter: '第 312 话',
    rating: 4.5,
    popularity: 1345000,
  },
  {
    id: 'comic-6',
    title: '银河边境',
    author: '星河',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20manga%20illustration%20of%20a%20space%20pilot%20with%20a%20high-tech%20helmet%20standing%20in%20front%20of%20a%20spaceship%2C%20neon%20accents%2C%20cyberpunk%20aesthetic%2C%20clean%20lineart%2C%20professional%20illustration%2C%20silver%20and%20teal%20color%20scheme&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'scifi',
    description: '公元 2350 年，人类在银河系建立了庞大的星际文明。年轻飞行员在边境地带展开冒险。',
    updateStatus: '连载中',
    latestChapter: '第 89 话',
    rating: 4.7,
    popularity: 567000,
  },
  {
    id: 'comic-7',
    title: '猫咪咖啡馆',
    author: '喵酱',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20manga%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20cute%20cats%20and%20a%20gentle%20barista%2C%20soft%20pastel%20colors%2C%20slice%20of%20life%20style%2C%20warm%20atmosphere%2C%20simple%20white%20background%2C%20relaxing%20and%20peaceful%20mood&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'slice',
    description: '藏在街角的猫咪咖啡馆，每只猫咪都有自己的故事。暖心的日常治愈系漫画。',
    updateStatus: '连载中',
    latestChapter: '第 45 话',
    rating: 4.8,
    popularity: 389000,
  },
  {
    id: 'comic-8',
    title: '剑道少女',
    author: '青竹',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20sports%20manga%20illustration%20of%20a%20female%20kendo%20fighter%20in%20action%20pose%20with%20a%20bamboo%20sword%2C%20intense%20expression%2C%20motion%20lines%2C%20traditional%20Japanese%20dojo%20background%20hint%2C%20professional%20manga%20art%2C%20clean%20and%20powerful%20composition&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'shonen',
    description: '少女为了继承家族道场，踏上剑道修行之路。热血与汗水的青春物语。',
    updateStatus: '已完结',
    latestChapter: '第 152 话（完）',
    rating: 4.9,
    popularity: 892000,
  },
  {
    id: 'comic-9',
    title: '异世界餐厅',
    author: '食为天',
    cover: 'https://readdy.ai/api/search-image?query=A%20delightful%20fantasy%20manga%20illustration%20of%20a%20cheerful%20chef%20serving%20delicious%20food%20to%20fantasy%20creatures%20in%20a%20magical%20restaurant%2C%20warm%20golden%20lighting%2C%20food%20focus%2C%20whimsical%20style%2C%20simple%20white%20background%2C%20cozy%20atmosphere&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: 'fantasy',
    description: '普通厨师穿越到异世界，用美食征服各路魔物和勇者的奇妙故事。',
    updateStatus: '连载中',
    latestChapter: '第 67 话',
    rating: 4.6,
    popularity: 678000,
  },
  {
    id: 'comic-10',
    title: '夏日蝉鸣时',
    author: '浅草',
    cover: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20romance%20manga%20illustration%20of%20two%20teenagers%20sitting%20on%20a%20riverbank%20during%20summer%20sunset%2C%20soft%20warm%20colors%2C%20cicada%20summer%20theme%2C%20youth%20and%20first%20love%20atmosphere%2C%20gentle%20art%20style%2C%20simple%20white%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: 'romance',
    description: '那年夏天，蝉鸣声声。他与她的故事，从一封未曾寄出的信开始。',
    updateStatus: '连载中',
    latestChapter: '第 34 话',
    rating: 4.7,
    popularity: 445000,
  },
  {
    id: 'comic-11',
    title: '机械纪元',
    author: '铁心',
    cover: 'https://readdy.ai/api/search-image?query=A%20mecha%20sci-fi%20manga%20illustration%20of%20a%20giant%20robot%20standing%20in%20a%20futuristic%20city%2C%20pilot%20in%20cockpit%2C%20mechanical%20details%2C%20metallic%20colors%2C%20action%20packed%20composition%2C%20professional%20illustration%2C%20clean%20lineart&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: 'scifi',
    description: '人类与机械共存的世界中，一场关乎文明存亡的战争正在展开。',
    updateStatus: '连载中',
    latestChapter: '第 78 话',
    rating: 4.5,
    popularity: 534000,
  },
  {
    id: 'comic-12',
    title: '深夜食堂故事',
    author: '夜食',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20manga%20illustration%20of%20a%20small%20late-night%20Japanese%20restaurant%20interior%20with%20customers%20at%20the%20counter%2C%20steaming%20food%2C%20dim%20warm%20lighting%2C%20slice%20of%20life%20style%2C%20nostalgic%20atmosphere%2C%20simple%20composition&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: 'slice',
    description: '深夜营业的小食堂里，每位食客都有属于自己的故事。',
    updateStatus: '连载中',
    latestChapter: '第 55 话',
    rating: 4.8,
    popularity: 456000,
  },
];